import { IG_TIERS, ImplementationGroup } from '@constants/entities/project';

export const getEntryTier = (
  membership: ImplementationGroup[] | undefined,
): ImplementationGroup | null =>
  IG_TIERS.find((tier) => membership?.includes(tier)) ?? null;

// Split so the active filter can be emphasised against the rest of the sentence
export const formatShowSummary = (
  activeTiers: ImplementationGroup[],
): { prefix: string; filter: string; suffix: string } => {
  if (!activeTiers.length)
    return { prefix: 'Showing ', filter: 'All', suffix: ' references' };

  const ascending = IG_TIERS.filter((tier) => activeTiers.includes(tier));

  return { prefix: 'Showing ', filter: ascending.join(', '), suffix: '' };
};

export const compareCisIds = (a: string, b: string): number => {
  const left = a.split('.').map(Number);
  const right = b.split('.').map(Number);
  const depth = Math.max(left.length, right.length);

  for (let i = 0; i < depth; i += 1) {
    const diff = (left[i] ?? -1) - (right[i] ?? -1);

    if (diff !== 0) return diff;
  }

  return 0;
};

export const sortedTagEntries = <T extends { value: string | number }>(
  value: T[],
): Array<{ option: T; index: number }> =>
  value
    .map((option, index) => ({ option, index }))
    .sort((a, b) =>
      compareCisIds(String(a.option.value), String(b.option.value)),
    );
